import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { SetInitialStateFacade } from '../../../../common/models';
import { FilterOptionsState } from './filter-options.state';
import {
  ConsigneePlantFilterOptionsLoad,
  InboundPlantFilterOptionsLoad,
  FilterOptionsInitialState,
  SapIdOptionsLoad,
  ShipToPlantFilterOptionsLoad,
  BusinessUnitsOptionsLoad,
  NetworkPartOptionsLoad,
  ConsignorAddressOptionsLoad,
  FreightPayerOptionsLoad,
  SourceLocationsOptionsLoad,
  DestinationLocationsOptionsLoad,
  PortOfLoadingOptionsLoad,
  PortOfDischargeOptionsLoad,
  SapSystemsOptionsLoad,
} from './filter-options.actions';
import {
  MonitoringFilterGateOption,
  MonitoringFilterPlantOption,
} from '../models/monitoring-filter-plant-option.model';

@Injectable({ providedIn: 'root' })
export class FilterOptionsFacade implements SetInitialStateFacade {
  inboundPlants: Observable<string[]> = this.store.select(FilterOptionsState.getInboundPlantOptions);
  shipToPlants: Observable<MonitoringFilterGateOption[]> = this.store.select(FilterOptionsState.getShipToPlantOptions);
  consigneePlants: Observable<MonitoringFilterPlantOption[]> = this.store.select(
    FilterOptionsState.getConsigneePlantOptions,
  );
  sapIds: Observable<string[]> = this.store.select(FilterOptionsState.sapIdOptions);
  businessUnits: Observable<string[]> = this.store.select(FilterOptionsState.businessUnitOptions);
  networkParts: Observable<string[]> = this.store.select(FilterOptionsState.networkPartOptions);
  consignorAddresses: Observable<{ name: string; city: string; country: string }[]> = this.store.select(
    FilterOptionsState.consignorAddressOptions,
  );
  freightPayers: Observable<{ extId: string; city: string }[]> = this.store.select(
    FilterOptionsState.freightPayersOptions,
  );

  sourceLocations: Observable<string[]> = this.store.select(FilterOptionsState.sourceLocationsOptions);

  destinationLocations: Observable<string[]> = this.store.select(FilterOptionsState.destinationLocationsOptions);

  portsOfLoading: Observable<{ abbreviation: string; cityName: string }[]> = this.store.select(
    FilterOptionsState.portsOfLoadingOptions,
  );

  portsOfDischarge: Observable<{ abbreviation: string; cityName: string }[]> = this.store.select(
    FilterOptionsState.portsOfDischargeOptions,
  );

  sapSystems: Observable<string[]> = this.store.select(FilterOptionsState.sapSystemsOptions);

  loaded$: Observable<boolean> = this.store.select(FilterOptionsState.getLoaded);

  constructor(private store: Store) {}

  inboundPlantsLoadAll(filter: string): void {
    this.store.dispatch(new InboundPlantFilterOptionsLoad(filter));
  }

  shipToPlantsLoadAll(filter: string): void {
    this.store.dispatch(new ShipToPlantFilterOptionsLoad(filter));
  }

  consigneePlantsLoadAll(filter: string): void {
    this.store.dispatch(new ConsigneePlantFilterOptionsLoad(filter));
  }

  sapIdsLoadAll(filter: string): void {
    this.store.dispatch(new SapIdOptionsLoad(filter));
  }

  businessUnitsLoadAll(filter: string): void {
    this.store.dispatch(new BusinessUnitsOptionsLoad(filter));
  }

  networkPartsLoadAll(filter: string): void {
    this.store.dispatch(new NetworkPartOptionsLoad(filter));
  }

  consignorAddressesLoadAll(filter: string): void {
    this.store.dispatch(new ConsignorAddressOptionsLoad(filter));
  }

  freightPayersLoadAll(filter: string): void {
    this.store.dispatch(new FreightPayerOptionsLoad(filter));
  }

  setInitialState(): void {
    this.store.dispatch(new FilterOptionsInitialState());
  }

  sourceLocationsLoadAll(filter: string): void {
    this.store.dispatch(new SourceLocationsOptionsLoad(filter));
  }

  destinationLocationsLoadAll(filter: string): void {
    this.store.dispatch(new DestinationLocationsOptionsLoad(filter));
  }

  portsOfLoadingLoadAll(filter: string): void {
    this.store.dispatch(new PortOfLoadingOptionsLoad(filter));
  }

  portsOfDischargeLoadAll(filter: string): void {
    this.store.dispatch(new PortOfDischargeOptionsLoad(filter));
  }

  sapSystemsLoadAll(filter: string): void {
    this.store.dispatch(new SapSystemsOptionsLoad(filter));
  }
}
